export const cabecalhos = [
  { text: "#", value: "item", width: "2%" },
  { text: 'Descrição Fornecedor', value: 'razao_social' },
  { text: "Cód. Interno", value: "idproduto" },
  { text: "Cód. Fornecedor", value: "cod_produto" },
  { text: "Descrição Produto", value: "descricao_produto" },
  // { text: "Peso (Kg)", class: 'text-start', value: "peso", width: "4%", align: 'center' },
  // { text: "Cubagem (M³)", class: 'text-start', value: "cubagem", width: "5%", align: 'center' },
  { text: "Última Compra", value: "data_ultima_requisicao" },
  { text: "Última Entrada", value: "data_ultima_entrada" },
  { text: "UND", value: "unidade_compra", width: "2%" },
  { text: "Sugerido", class: 'text-start', value: "sugerido", width: "4%" },
  { text: "Quantidade", value: "qtde_pedido", align: "center", width: "7%" },
  { text: "Cobertura Estoque Futura (dias)", class: 'text-start', value: "cobertura_estoque_futura", sortable: false, width: "8%" },
  { text: "Último Preço", value: "preco_custo_base", class: 'text-start', width: "6%", align: "center" },
  { text: "Preço Atual", value: "preco_custo", align: "center", width: "7%" },
  { text: "Indicador (%)", class: 'text-start', value: "indicador", align: "center", width: "5%" },
  { text: "Preço Total", class: 'text-start', value: "total", width: "7%" },
  { text: "Preço Líquido Total", class: 'text-start', value: "preco_liquido_total", width: "7%", align: "center" },
  { text: "ABC F.", value: "classificacao_rentabilidade", sortable: false, width: "7%", align: "center" },
  { text: "ABC R.", value: "classificacao_criticidade", sortable: false, width: "7%", align: "center" },
  { text: "Ações", value: "action", sortable: false, width: "2%" },
]
